import React, { useRef } from 'react'
import styled from 'styled-components'
import WrapTest from '../Components/WrapTest'
import { useScroll, useTransform } from 'framer-motion'
import { motion } from 'framer-motion'
import ExtraProject from '../Extra/ExtraProject'

const Projects = () => {

  const project = useRef(null)
  const projectHead = useRef(null)

  const { scrollYProgress } = useScroll({
    target: project.current,
    offset: ["start end", "end start"]
  })

  const progress = useScroll({
    target: projectHead,
    offset: ["start end", "end start"]
  })

  const scale = useTransform(progress.scrollYProgress, [0, 0.9, 1], [0, 1.25, 0.5]);
  const opacity = useTransform(progress.scrollYProgress, [0, 0.9, 1], [0, 1, 0]);

  const height = useTransform(scrollYProgress, [0, 1], ['20vh', '0vh'])

  return (
    <div className='projects' ref={project} >
      <ProjectDiv className='ProjectDiv' ref={projectHead} >
        <motion.h1
          style={{ scale, opacity }}
          className='heading'>
          Projects
        </motion.h1>
      </ProjectDiv>

      <ExtraProject />
      <WrapTest />

      <motion.div
        style={{ height }}
        className="circleContainer">
        <div className="circle"></div>
      </motion.div>
    </div>
  )
}

export default Projects


const ProjectDiv = styled.div`
align-self: center;
width: 100%;
display: flex;
justify-content: center;
align-items: center;
padding-top: 20vh;

h1{
  text-transform: uppercase;
  font-family: var(--font1);
  font-size: 5rem;
  letter-spacing: 0.3rem;

  @media only screen and (max-width: 570px) {
    font-size: 3rem; !important;
  }
}
`
